import React, { useState, useRef,useEffect } from 'react';
import '../../assets/vendor/css/pages/page-auth.css'
import { Link, useNavigate } from 'react-router-dom';

import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { getToken, setUserSession } from '../../helpers/Helper';
import { POST_FORGOT_PASSWORD, POST_RESET_PASSWORD } from '../../helpers/url_helper';
import { toast } from 'react-toastify';

import Auth_Img from './../../assets/img/auth_img.png';
import { useTranslation } from 'react-i18next';
import Logo from './../../assets/img/logo.svg';

const ForgotPassword = (props) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    useEffect(() => {
        if (getToken()) {
            navigate("/dashboard");
        }
    }, [navigate])

    const simpleValidator = useRef(new SimpleReactValidator());
    const OtpValidator = useRef(new SimpleReactValidator());

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [otp_screen, SetOTP_screen] = useState(false);
    const [form_inputs, setInputs] = useState({ email: '', password: '', c_password: '', otp: '',captcha: '' });
    const [, forceUpdate] = useState();

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_FORGOT_PASSWORD, { 'email': form_inputs.email }, {});
            if (res_data.status) {
                SetOTP_screen(true);
                toast(res_data.message);
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // form submit event
    const verifyOtp = async (event) => {
        event.preventDefault();
        const formValid = OtpValidator.current.allValid()
        if (!formValid) {
            OtpValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_RESET_PASSWORD, form_inputs, {});
            if (res_data.status) {
                setUserSession(res_data.data.token, res_data.data);
                navigate("/dashboard");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }

    return (
        <>
            <div>

            </div>
            <div className="authentication-wrapper authentication-cover">
                <div className="authentication-inner row m-0">
                    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                        <div className="w-100 d-flex justify-content-center">
                            <img src={Auth_Img} className="img-fluid" alt="Login" width="700" />
                        </div>
                    </div>

                    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                        <div className="w-px-400 mx-auto">
                            <div className="app-brand mb-5">
                                    <img src={Logo} alt='Cheque Print' style={{"width" : '300px'}} /> 
                            </div>
                            <h4 className="mb-2">{t('forgotPassword.Title')}</h4>
                            <p className="mb-4">{t('forgotPassword.SubTitle')}</p>
                            {!otp_screen && <>
                                <form id="formAuthentication" className="mb-3"  onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label>{t('forgotPassword.form.emailAddress')}</label>
                                        <input name="email" className="form-control" value={form_inputs.email} onChange={handleInputChange} placeholder={t('forgotPassword.Placeholder.emailAddress')} type="text" autoFocus />
                                        {simpleValidator.current.message('email', form_inputs.email, 'required|email',{messages : { required : t('forgotPassword.formError.emailAddressRequired'), email : t('forgotPassword.formError.emailAddressValid')}})}
                                    </div>
                                    <button disabled={ButtonDisabled} className="btn btn-primary w-100">{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('forgotPassword.sendResetLink')}</button>
                                </form>
                                <div className="text-center">
                                    <Link to="/" className="d-flex align-items-center justify-content-center text-primary">
                                        <i className="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                                        {t('forgotPassword.backToLogin')}
                                    </Link>
                                </div>
                            </>}

                            {otp_screen && <>
                                <form id="formAuthentication" className="mb-3" onSubmit={verifyOtp}>
                                    <div className="mb-3">
                                        <label className="text-uppercase">{t('forgotPassword.form.otp')}</label>
                                        <input name="otp" className="form-control" maxLength="6" value={form_inputs.otp} onChange={handleInputChange} placeholder={t('forgotPassword.Placeholder.otp')} type="text" />
                                        {OtpValidator.current.message('otp', form_inputs.otp, 'required|numeric|min:6', {messages : {
                                            required : t('forgotPassword.formError.otpRequired'),
                                            numeric : t('forgotPassword.formError.otpNumeric'),
                                            min : t('forgotPassword.formError.otpMin')
                                        }})}
                                    </div>
                                    <div className="mb-3">
                                        <label>{t('forgotPassword.form.password')}</label>
                                        <input name="password" className="form-control" value={form_inputs.password} onChange={handleInputChange} placeholder={t('forgotPassword.Placeholder.password')} type="password" />
                                        {OtpValidator.current.message('password', form_inputs.password, 'required',{messages : {required : t('forgotPassword.formError.passwordRequired')}})}
                                    </div>
                                    <div className="mb-3">
                                        <label>{t('forgotPassword.form.confirmPassword')}</label>
                                        <input name="c_password" className="form-control" value={form_inputs.c_password} onChange={handleInputChange} placeholder={t('forgotPassword.form.confirmPassword')} type="password" />
                                        {OtpValidator.current.message('confirm password', form_inputs.c_password, `required|in:${form_inputs.password}`, { messages: {required :  t('forgotPassword.formError.confirmPasswordRequired'), in: t('forgotPassword.formError.confirmPasswordIn') } })}
                                    </div>
                                    <button disabled={ButtonDisabled} className="btn btn-primary w-100">{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('forgotPassword.changePassword')}</button>
                                </form>
                                <div className="text-center">
                                    <Link to="/" className="d-flex align-items-center justify-content-center text-primary">
                                        <i className="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                                        {t('forgotPassword.backToLogin')}
                                    </Link>
                                </div>
                            </>}


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ForgotPassword;